import { h } from 'preact';
import { TransparentButtonWrapper } from './TransparentButton.styled';

const TransparentButton = props => <TransparentButtonWrapper {...props} />;

export default TransparentButton;
